import Chart, { Props } from "react-apexcharts";

interface IData {
    x: number | string;
    y: number | string;
}

interface ISerie {
    data: Array<number> | Array<Array<number>> | Array<IData>;
    name?: string;
}

interface BidimencionalChartProps extends Props {
    series: Array<ISerie>;
    type: "bar" | "line";
}

export default function BidimencionalChart(props: BidimencionalChartProps) {
    return (
        <Chart
            series={props.series}
            options={{
                ...props.options,
            }}
            type={props.type}
        />
    );
}

//#region interfaces úteis para montar os gráficos

export interface ITimelineChartData {
    datas: Array<number>;
    dados: Array<number>;
}
export interface ITimelineChartPoliData {
    dados: Array<{
        data: Array<number>;
        name: string;
    }>;
    datas: Array<number>;
}

//#endregion
